import { Directive, Input, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: 'img[imgFallback]'
})
export class ImgFallbackDirective {
  @Input() imgFallback: string = './assets/images/placeholders/img.png';

  constructor(private el: ElementRef<HTMLImageElement>) {}

  @HostListener('error')
  onError(): void {
    const img = this.el.nativeElement;
    // evita loop infinito se anche il placeholder fallisce
    img.src = this.imgFallback;
    img.onerror = null;
  }
}
